module.exports = __webpack_public_path__ + "img/3-2.8729ed85.svg";